var render, staticRenderFns
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d0796e')) {
      api.createRecord('07d0796e', component.options)
    } else {
      api.reload('07d0796e', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/User/resources/vue/UserProfile.vue"
export default component.exports